<template>
	<my-dialog :visible.sync="showDialog" title="加工部订单详情" dialog-type="form" :close-on-click-modal="false" width="80%" @close="closeDialog">
		<!-- <el-steps
      :active="active"
      finish-status="success"
      style="margin-bottom: 20px"
    >
      <el-step title="步骤 1"></el-step>
      <el-step title="步骤 2"></el-step>
      <el-step title="步骤 3"></el-step>
    </el-steps>

    <div style="text-align: center; margin-bottom: 20px">
      <el-button
        type="primary"
        style="margin-top: 12px; margin-top: auto; margin-right: auto"
        @click="stepNext"
        >下一步</el-button
      >
    </div> -->

		<detail
			:detail-row="detailRow"
			:detail-type="detailType"
			:is-show-warehouse-qty="true"
			:show-record-toggle="true"
			:op-log-visible="opLogVisible"
			:output-visible="outputVisible"
			@op-log-change="handleOpLogChange"
			@output-change="handleOutputChange"
		></detail>

		<!-- 出库记录（开关开启且有出库数据时才展示） -->
		<div v-if="outputVisible && outputOrderList.length > 0" v-loading="loading" class="margin-top" element-loading-text="加载中...">
			<div v-for="(outDtl, index) in outputOrderList" :key="index" class="item_info">
				<el-descriptions class="margin-top" title="出库单信息" :column="3" border>
					<el-descriptions-item label="出库单号">{{ outDtl.outputStoreNo }}</el-descriptions-item>
					<el-descriptions-item label="出库时间">{{ outDtl.outputDate }}</el-descriptions-item>
					<el-descriptions-item label="出库状态">{{ outDtl.outputStateStr }}</el-descriptions-item>
					<el-descriptions-item label="备注" span="3">{{ outDtl.remark }}</el-descriptions-item>

					<el-descriptions-item label="商品信息" span="3">
						<el-table :cell-class-name="$moneyCellClass"
							:data="outDtl.dtls"
							style="width: 100%; height: 300rpx; border-radius: 10px"
							border
							:header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
							:cell-style="{ textAlign: 'center' }"
						>
							<el-table-column type="index" label="序号" width="60"></el-table-column>
							<el-table-column prop="goodsInfo.type" label="商品品牌" width="120"></el-table-column>
							<el-table-column prop="goodsInfo.name" label="商品名称"></el-table-column>
							<el-table-column prop="goodsInfo.qiuJing" label="球镜" width="80"></el-table-column>
							<el-table-column prop="goodsInfo.zhuJing" label="柱镜" width="80"></el-table-column>
							<el-table-column prop="goodsInfo.unit" label="单位" width="80"></el-table-column>
							<el-table-column prop="quantity" label="数量" width="155"></el-table-column>
							<el-table-column prop="remark" label="ADD"></el-table-column>
						</el-table>
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</div>

		<!-- 操作记录（开关开启时才展示） -->
		<div v-show="opLogVisible" class="item_info margin-top">
			<div class="item_title">
				<div class="title">操作记录</div>
			</div>
			<operationLog ref="operationLog"></operationLog>
		</div>

		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">关闭</el-button>
				<el-button v-if="(state === 7 || state == 3 || state === 11) && orderType === 1 && $checkBtnPermission('/jgborder/index', 'auditOrer')" size="small" type="primary" @click="AuditOrer">
					库存片审核
				</el-button>
				<el-button
					v-if="(state === 7 || state == 3 || state === 11) && orderType === 1 && $checkBtnPermission('/jgborder/index', 'adminAuditOrer')"
					size="small"
					type="primary"
					@click="AdminAuditOrer"
				>
					更改库存片审核
				</el-button>
				<el-button
					v-if="(state === 7 || state === 11) && orderType === 1 && $checkBtnPermission('/jgborder/index', 'createPurchaseAuditOrer')"
					size="small"
					type="primary"
					@click="CreatePurchaseAuditOrer"
				>
					创建采购单审核
				</el-button>
				<el-button v-if="(state === 7 || state == 11) && orderType === 1 && $checkBtnPermission('/jgborder/index', 'return')" size="small" type="danger" @click="handleReturnOrder">退回订单</el-button>
				<el-button v-if="state === 4 && orderType === 1 && $checkBtnPermission('/jgborder/index', 'createOutputStore')" size="small" type="danger" @click="handleCreateOutputStore">
					创建出库单
				</el-button>
				<el-button
					v-if="(state === 4 || state === 5) && orderType === 1 && $checkBtnPermission('/jgborder/index', 'editGoodsOutput')"
					size="small"
					type="danger"
					@click="handleEditGoodsInfoOutputStore"
				>
					更换商品出库
				</el-button>
				<el-button v-if="state === 5 && orderType === 1 && $checkBtnPermission('/jgborder/index', 'redistributeOutputStore')" size="small" type="success" @click="handleRedistributeOutputStore">
					重新出库
				</el-button>
			</div>
		</template>
		<el-dialog :visible.sync="innerVisible" width="75%" title="选择需要重新出库的商品信息" append-to-body>
			<el-table :cell-class-name="$moneyCellClass"
				:data="goodsTableDataSelect"
				style="width: 100%; border-radius: 10px"
				:show-overflow-tooltip="true"
				border
				:header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
				:cell-style="{ textAlign: 'center' }"
				@selection-change="selectionTableRowData"
			>
				<el-table-column type="selection" label="选择" width="80"></el-table-column>
				<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
				<el-table-column prop="lr" label="左右眼" width="100">
					<template #default="scope">
						<el-select v-model.number="scope.row.lr" placeholder="请选择" size="small" disabled>
							<el-option key="0" label="右眼" :value="0"></el-option>
							<el-option key="1" label="左眼" :value="1"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column prop="goodsInfo.type" label="商品品牌" width="120"></el-table-column>
				<el-table-column prop="goodsInfo.name" label="商品名称"></el-table-column>
				<el-table-column prop="goodsInfo.qiuJing" label="球镜" width="86"></el-table-column>
				<el-table-column prop="goodsInfo.zhuJing" label="柱镜" width="60"></el-table-column>
				<el-table-column prop="zhouWei" label="轴位" width="120"></el-table-column>
				<el-table-column prop="goodsInfo.unit" label="单位" width="60"></el-table-column>
				<el-table-column prop="quantity" label="数量" width="160">
					<template #default="scope">
						<el-input-number v-model.number="scope.row.quantity" placeholder="请输入数量" size="small" :min="0" :step="1"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="wareHouseQuantity" label="库存数量" width="100">
					<template #default="scope">
						<span v-if="scope.row.wareHouseQuantity >= scope.row.quantity">{{ scope.row.wareHouseQuantity }}</span>
						<span v-else style="display: block; background-color: #ff0000">{{ scope.row.wareHouseQuantity }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="ADD"></el-table-column>
			</el-table>
			<template #footer>
				<div class="dialog-footer">
					<el-button size="small" @click="closeDialogSelect">关闭</el-button>
					<el-button size="small" type="primary" @click="handleSaveRedistributeOutputStore">确认</el-button>
				</div>
			</template>
		</el-dialog>
		<el-dialog :visible.sync="editGoodsVisible" width="75%" title="更换商品出库" append-to-body>
			<el-table :cell-class-name="$moneyCellClass"
				:data="editGoodsTableDataSelect"
				style="width: 100%; border-radius: 10px"
				:show-overflow-tooltip="true"
				border
				:header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
				:cell-style="{ textAlign: 'center' }"
			>
				<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
				<el-table-column prop="lR" label="左右眼" width="100">
					<template #default="scope">
						<el-select v-model.number="scope.row.lR" placeholder="请选择" size="small" disabled>
							<el-option key="0" label="右眼" :value="0"></el-option>
							<el-option key="1" label="左眼" :value="1"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="商品品牌" width="120"></el-table-column>
				<el-table-column prop="name" label="商品名称"></el-table-column>
				<el-table-column prop="qiuJing" label="球镜" width="86"></el-table-column>
				<el-table-column prop="zhuJing" label="柱镜" width="60"></el-table-column>
				<el-table-column prop="zhouWei" label="轴位" width="120"></el-table-column>
				<el-table-column prop="unit" label="单位" width="60"></el-table-column>
				<el-table-column prop="quantity" label="数量" width="160">
					<template #default="scope">
						<el-input-number v-model.number="scope.row.quantity" placeholder="请输入数量" size="small" :min="0" :step="1"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="wareHouseQuantity" label="库存数量" width="100">
					<template #default="scope">
						<span v-if="scope.row.wareHouseQuantity >= scope.row.quantity">{{ scope.row.wareHouseQuantity }}</span>
						<span v-else style="display: block; background-color: #ff0000">{{ scope.row.wareHouseQuantity }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="ADD"></el-table-column>
				<el-table-column prop="operate" label="操作">
					<template #default="scope">
						<el-button type="primary" size="small" icon="el-icon-plus" @click="showSelectEditGoodsDialog(scope.row.lR)">更换商品</el-button>
					</template>
				</el-table-column>
			</el-table>
			<template #footer>
				<div class="dialog-footer">
					<el-button size="small" @click="closeEpditGoodsDialogSelect">关闭</el-button>
					<el-button size="small" type="primary" @click="handleSaveEditGoodsOutputStore">确认出库</el-button>
				</div>
			</template>
		</el-dialog>
	</my-dialog>
</template>
<script>
import { AuditStoreOrder, GetStoreOrderDetail, ReturnStoreOrder, GetGoodsWareHouseDetail, AdminAuditStoreOrder, CreatePurchaseAuditStoreOrder } from "@/api/storeOrderApi.js";
import { CreateOutputStore, RedistributeOutputStore, CreateEditOutputStore, GetOrderOutputList } from "@/api/receiptApi.js";
import detail from "./detail.vue";
import operationLog from "@/views/system/operationLog/businessOperationLog.vue";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			active: 0,
			loading: false,
			editForm: {
				keyId: ""
			},
			orderType: 1,
			state: 0,
			innerVisible: false,
			goodsTableDataSelect: [],
			goodsIndex: 1,
			selectionRowData: [],
			editGoodsVisible: false,
			editGoodsTableDataSelect: [],
			selectRowLR: 0,
			outputOrderList: [],
			currentRow: null,
			detailRow: null,
			detailType: 1,
			// 操作记录/出库记录 展示开关（默认不展示，状态不随关闭弹窗重置）
			opLogVisible: false,
			outputVisible: false
		};
	},
	computed: {},
	components: {
		detail,
		operationLog
	},
	created() {},
	methods: {
		// 显示
		showSeeDetailDialog(row, type = 1) {
			this.editForm.keyId = row.keyId;
			this.state = row.state;
			this.orderType = type;
			this.resetData();
			this.detailType = type;
			this.showDialog = true;
			this.loading = true;
			this.$nextTick(() => {
				this.detailRow = { ...row };
			});
			// 加载该订单的操作记录
			this.$nextTick(() => {
				this.$refs.operationLog.showOperationLog(row.keyId);
			});
			GetOrderOutputList({ keyId: row.keyId })
				.then((outputRes) => {
					if (outputRes.code == 1) {
						this.outputOrderList = outputRes.data;
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
			this.loading = false;
		},
		// 操作记录开关变化
		handleOpLogChange(val) {
			this.opLogVisible = val;
		},
		// 出库记录开关变化
		handleOutputChange(val) {
			this.outputVisible = val;
		},
		stepNext() {
			if (this.active++ > 2) return;
		},
		// 加工部审核订单
		AuditOrer() {
			this.loading = false;
			this.$confirm("确定审核订单吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: this.editForm.keyId
					};
					AuditStoreOrder(params)
						.then((res) => {
							if (res.code == 1) {
								this.$confirm(res.msg, "信息", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning"
								})
									.then(() => {
										this.showDialog = false;
										this.$parent.getListData();
									})
									.catch(() => {
										this.$message({
											type: "error",
											message: "已取消审核！"
										});
									});
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("订单审核失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消审核！"
					});
				});
		},
		// 管理员审核订单
		AdminAuditOrer() {
			this.loading = false;
			this.$confirm("确定不检测库存数量审核订单吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: this.editForm.keyId
					};
					AdminAuditStoreOrder(params)
						.then((res) => {
							if (res.code == 1) {
								this.$confirm(res.msg, "信息", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning"
								})
									.then(() => {
										this.showDialog = false;
										this.$parent.getListData();
									})
									.catch(() => {
										this.$message({
											type: "error",
											message: "已取消审核！"
										});
									});
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("订单审核失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消审核！"
					});
				});
		},
		// 创建采购审核订单
		CreatePurchaseAuditOrer() {
			this.loading = false;
			this.$confirm("确定直接创建采购单审核订单吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: this.editForm.keyId
					};
					CreatePurchaseAuditStoreOrder(params)
						.then((res) => {
							if (res.code == 1) {
								this.$confirm(res.msg, "信息", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning"
								})
									.then(() => {
										this.showDialog = false;
										this.$parent.getListData();
									})
									.catch(() => {
										this.$message({
											type: "error",
											message: "已取消审核！"
										});
									});
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("订单审核失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消审核！"
					});
				});
		},
		// 加工部创建出库单
		handleCreateOutputStore() {
			this.loading = false;
			this.$confirm("确定创建出库单吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: this.editForm.keyId
					};
					CreateOutputStore(params)
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "创建出库单成功！"
								});
								this.showDialog = false;
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("创建出库单失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消创建出库单！"
					});
				});
		},
		// 更换商品创建出库单
		handleEditGoodsInfoOutputStore() {
			this.$confirm("确定更换商品创建出库单吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.editGoodsVisible = true;
					GetStoreOrderDetail({
						keyId: this.editForm.keyId
					}).then((res) => {
						if (res.code == 1) {
							this.goodsIndex = 1;
							this.editGoodsTableDataSelect = [];
							res.data.dtls.forEach((item) => {
								var info = {};
								info.rowNumber = item.lr === 0 ? 1 : 2;
								info.lR = item.lr;
								info.quantity = item.quantity;
								info.name = item.goodsInfo.name;
								info.type = item.goodsInfo.type;
								info.unit = item.goodsInfo.unit;
								info.qiuJing = item.goodsInfo.qiuJing;
								info.zhuJing = item.goodsInfo.zhuJing;
								info.goodsKeyId = item.goodsKeyId;
								info.remark = item.remark;
								info.zhouWei = item.zhouWei;
								info.wareHouseQuantity = item.wareHouseQuantity;
								this.editGoodsTableDataSelect.push(info);
							});
						} else {
							this.$message({
								type: "error",
								message: res.msg
							});
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消更换商品创建出库单！"
					});
				});
		},
		handleSaveEditGoodsOutputStore() {
			let params = {
				storeOrderKeyId: this.editForm.keyId
			};
			params.dtls = this.editGoodsTableDataSelect.map((item) => ({
				keyId: item.goodsKeyId,
				lr: item.lR,
				quantity: item.quantity,
				remark: item.remark,
				zhouWei: item.zhouWei
			}));
			CreateEditOutputStore(params).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: "更换商品创建出库单成功！"
					});
					this.editGoodsVisible = false;
					this.$parent.getListData();
				} else {
					this.$message({
						type: "error",
						message: res.msg
					});
				}
			});
		},
		// 展示选择商品弹窗
		showSelectEditGoodsDialog(lr) {
			let paramsKeyId1 = this.editGoodsTableDataSelect[lr].qiuJing;
			let paramsKeyId2 = this.editGoodsTableDataSelect[lr].zhuJing;
			this.$parent.showSelectGoods(1, paramsKeyId1, paramsKeyId2);
			this.selectRowLR = lr;
		},
		// 选中商品
		submitSelectGoods(list) {
			let item = list[0];
			var info = {};
			info.rowNumber = this.selectRowLR === 0 ? 1 : 2;
			info.lR = this.selectRowLR;
			info.quantity = this.editGoodsTableDataSelect[this.selectRowLR].quantity;
			info.name = item.name;
			info.type = item.type;
			info.unit = item.unit;
			info.qiuJing = item.qiuJing;
			info.zhuJing = item.zhuJing;
			info.goodsKeyId = item.keyId;
			info.remark = this.editGoodsTableDataSelect[this.selectRowLR].remark;
			info.zhouWei = this.editGoodsTableDataSelect[this.selectRowLR].zhouWei;
			info.wareHouseQuantity = 0;
			// 调用接口获取商品库存信息详情
			GetGoodsWareHouseDetail({
				keyId: item.keyId
			}).then((res) => {
				if (res.code == 1) {
					info.wareHouseQuantity = res.data.quantity;
				} else {
					this.$message({
						type: "error",
						message: res.msg
					});
				}
			});
			this.$set(this.editGoodsTableDataSelect, this.selectRowLR, info);
		},
		// 加工部重新出库
		handleRedistributeOutputStore() {
			this.$confirm("确定重新出库吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.innerVisible = true;

					GetStoreOrderDetail({
						keyId: this.editForm.keyId
					}).then((res) => {
						if (res.code == 1) {
							this.goodsIndex = 1;
							this.goodsTableDataSelect = res.data.dtls;
							this.goodsTableDataSelect.forEach((item) => {
								item.rowNumber = this.goodsIndex++;
							});
						} else {
							this.$message({
								type: "error",
								message: res.msg
							});
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消重新出库！"
					});
				});
		},
		// 加工部创建门店采购订单
		handleCteateStorePurchaseOrder() {
			this.$confirm("确定创建门店采购订单吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: this.editForm.keyId
					};
					CteateStorePurchaseOrder(params)
						.then((res) => {
							if (res.code == 1) {
								this.$confirm(res.msg, "信息", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning"
								})
									.then(() => {
										this.showDialog = false;
										this.$parent.getListData();
									})
									.catch(() => {
										this.$message({
											type: "error",
											message: "已取消创建门店采购订单！"
										});
									});
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch(() => {
							this.$message({
								type: "error",
								message: "已取消创建门店采购订单！"
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消创建门店采购订单！"
					});
				});
		},
		// 加工部重新出库
		handleSaveRedistributeOutputStore() {
			let params = {
				storeOrderKeyId: this.editForm.keyId,
				dtls: this.selectionRowData
			};
			RedistributeOutputStore(params)
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg
						});
						this.innerVisible = false;
						this.showDialog = false;
						this.$parent.getListData();
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("重新出库失败，请稍后再试！");
				});
		},
		// 加工部退回订单
		handleReturnOrder() {
			this.loading = false;
			this.$confirm("确定退回订单吗？", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let params = {
						keyId: this.editForm.keyId
					};
					ReturnStoreOrder(params)
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "订单退回成功！"
								});
								this.showDialog = false;
								this.$parent.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("退回订单失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "已取消退回订单！"
					});
				});
		},
		closeDialogSelect() {
			this.innerVisible = false;
		},
		closeEpditGoodsDialogSelect() {
			this.editGoodsVisible = false;
		},
		selectionTableRowData(val) {
			this.selectionRowData = [];
			val.forEach((item) => {
				this.selectionRowData.push({
					keyId: item.keyId,
					quantity: item.quantity
				});
			});
		},
		// 获取订单的出库信息
		getOrderOutputList() {
			// 清空上一次的数据，显示加载中
			this.resetData();
			this.loading = true;
			GetOrderOutputList({
				keyId: this.editForm.keyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.outputOrderList = res.data;
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.outputOrderList = [];
		}
	}
};
</script>
<style scoped lang="scss">
.item_info {
	border-left: 5px solid #55aaff;
	padding: 5px 10px;
	border-radius: 5px;
	margin-left: 10px;
	margin-right: 10px;
	margin-bottom: 15px;
	border-bottom: 2px solid #e9e7e7;
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;
}

.item_title .title {
	display: inline-block;
	unicode-bidi: isolate;
}

.item_title .btnDiv {
	display: block;
	unicode-bidi: isolate;
	word-break: break-all;
}
</style>
